function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import _styled from "styled-components";
var _excluded = ["id", "depth", "label", "show", "renderLeftIcon", "isDisabled", "isExpandable", "isSingleSelectable", "isMultiSelectable", "isExpanded", "isSelected", "isHighlighted", "onExpand", "onSelect", "renderWrapper", "children", "onMouseDown", "onMouseUp", "onMouseLeave", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import AnimateHeight from '@adsk/alloy-react-animate-height';
import Checkbox from '@adsk/alloy-react-checkbox';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import ExpandButton from './layout/ExpandButton';
import Indent from './layout/Indent';
import Label from './layout/Label';
var getBackgroundColor = function getBackgroundColor(props) {
  if (props.isSingleSelectable && props.isSelected) {
    return theme.colors._adskBlue100Alpha;
  } else if (props.isPressed && !props.isDisabled) {
    return theme.colors.charcoal100;
  } else if (props.isHighlighted) {
    return theme.colors.charcoal050;
  }
  return undefined;
};
var StyledLi = styled.li.withConfig({
  displayName: "TreeNode__StyledLi",
  componentId: "sc-sfvbyj-0"
})(["display:flex;flex-flow:row nowrap;align-items:center;user-select:none;width:100%;height:40px;overflow:hidden;padding:0 10px;cursor:", ";color:", ";background-color:", ";&:hover{background-color:", ";}"], function (props) {
  return props.rowClick ? 'pointer' : props.isDisabled ? 'default' : undefined;
}, function (props) {
  return props.isDisabled ? theme.colors.charcoal500 : undefined;
}, function (props) {
  return getBackgroundColor(props);
}, function (props) {
  return props.isSingleSelectable && props.isSelected ? "".concat(theme.colors.adskBlue100, " + '45'") : undefined;
});
var _StyledStyledLi = styled(StyledLi).withConfig({
  displayName: "TreeNode___StyledStyledLi",
  componentId: "sc-sfvbyj-1"
})(["", ""], function (p) {
  return p.$_css;
});
var TreeNode = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id,
    depth = _ref.depth,
    label = _ref.label,
    show = _ref.show,
    renderLeftIcon = _ref.renderLeftIcon,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isExpandable = _ref.isExpandable,
    isExpandable = _ref$isExpandable === void 0 ? false : _ref$isExpandable,
    _ref$isSingleSelectab = _ref.isSingleSelectable,
    isSingleSelectable = _ref$isSingleSelectab === void 0 ? false : _ref$isSingleSelectab,
    _ref$isMultiSelectabl = _ref.isMultiSelectable,
    isMultiSelectable = _ref$isMultiSelectabl === void 0 ? false : _ref$isMultiSelectabl,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    _ref$isHighlighted = _ref.isHighlighted,
    isHighlighted = _ref$isHighlighted === void 0 ? false : _ref$isHighlighted,
    _onExpand = _ref.onExpand,
    onSelect = _ref.onSelect,
    _ref$renderWrapper = _ref.renderWrapper,
    renderWrapper = _ref$renderWrapper === void 0 ? function (p) {
      return /*#__PURE__*/React.createElement(AnimateHeight, _extends({
        isOpen: p.show
      }, p));
    } : _ref$renderWrapper,
    children = _ref.children,
    onMouseDown = _ref.onMouseDown,
    onMouseUp = _ref.onMouseUp,
    onMouseLeave = _ref.onMouseLeave,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var rowClick = useMemo(function () {
    if (isDisabled) return undefined;
    // entire row click is for selection primarily
    if (isSingleSelectable || isMultiSelectable) {
      return onSelect ? function () {
        return onSelect({
          isSelected: !isSelected,
          id: id
        });
      } : undefined;
    }
    // if row isn't selectable, we can use the row click for expanding
    if (isExpandable) {
      return _onExpand ? function () {
        return _onExpand({
          isExpanded: !isExpanded,
          id: id
        });
      } : undefined;
    }
    // otherwise row is not clickable
    return undefined;
  }, [id, onSelect, _onExpand, isSingleSelectable, isMultiSelectable, isExpandable, isExpanded, isSelected, isDisabled]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPressed = _useState2[0],
    setIsPressed = _useState2[1];
  var onMouseDownHandler = useCallback(function (e) {
    setIsPressed(true);
    onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
  }, [onMouseDown]);
  var onMouseUpHandler = useCallback(function (e) {
    setIsPressed(false);
    onMouseUp === null || onMouseUp === void 0 ? void 0 : onMouseUp(e);
  }, [onMouseUp]);
  var onMouseLeaveHandler = useCallback(function (e) {
    setIsPressed(false);
    onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(e);
  }, [onMouseLeave]);
  return renderWrapper({
    show: show,
    'data-testid': "TreeNodeAnimateHeight_".concat(id),
    children: /*#__PURE__*/React.createElement(_StyledStyledLi, _extends({
      ref: ref,
      isHighlighted: isHighlighted,
      isPressed: isPressed,
      rowClick: !!rowClick,
      isSingleSelectable: isSingleSelectable,
      isSelected: !!isSelected,
      isDisabled: isDisabled,
      onClick: rowClick,
      onMouseDown: onMouseDownHandler,
      onMouseUp: onMouseUpHandler,
      onMouseLeave: onMouseLeaveHandler
    }, props, {
      $_css: style
    }), /*#__PURE__*/React.createElement(Indent, {
      depth: isExpandable ? depth : (depth !== null && depth !== void 0 ? depth : 0) + 1
    }), children || /*#__PURE__*/React.createElement(React.Fragment, null, isExpandable && /*#__PURE__*/React.createElement(ExpandButton, {
      style: {
        /* total width must equal indent unit of 30 */
        margin: '0 3px'
      },
      isExpanded: isExpanded,
      onExpand: function onExpand(changes) {
        return _onExpand === null || _onExpand === void 0 ? void 0 : _onExpand(_objectSpread(_objectSpread({}, changes), {}, {
          id: id
        }));
      }
    }), isMultiSelectable && /*#__PURE__*/React.createElement(Checkbox, {
      style: {
        margin: '0 7px'
      },
      "data-testid": "Checkbox",
      disabled: isDisabled,
      checked: isSelected,
      onChange: function onChange(val) {
        return onSelect === null || onSelect === void 0 ? void 0 : onSelect({
          id: id,
          isSelected: val
        });
      }
    }), renderLeftIcon === null || renderLeftIcon === void 0 ? void 0 : renderLeftIcon({
      style: {
        /* total width must equal indent unit of 30 */
        margin: '0 3px',
        minWidth: 24
      }
    }), /*#__PURE__*/React.createElement(Label, null, label)))
  });
});
TreeNode.displayName = 'TreeNode';
TreeNode.propTypes = {
  /* Unique identifier for the current node */
  id: PropTypes.string.isRequired,
  /* Determines whether or not to visibly render the node */
  show: PropTypes.bool.isRequired,
  /* The nesting level for this node. Ex. if the node has a parent and grandparent the
   * depth would be 2.
   */
  depth: PropTypes.number,
  /* Text to be rendered on the node */
  label: PropTypes.string.isRequired,
  /* The icon to render on the left side of the label */
  renderLeftIcon: PropTypes.func,
  /* Determines if the node is currently disabled, if applicable */
  isDisabled: PropTypes.bool,
  /* Determines if the node is currently expanded, if applicable */
  isExpanded: PropTypes.bool,
  /* Determines if the node is currently selected, if applicable */
  isSelected: PropTypes.oneOf([true, false, 'indeterminate']),
  /* Handler for expanding the current node, in order to show its children */
  onExpand: PropTypes.func,
  /* Handler for selecting the current node */
  onSelect: PropTypes.func,
  /* Render the parent element which wraps the tree node markup, defaults to an animate
   * height element
   */
  renderWrapper: PropTypes.func,
  /* Handler function for mouse down event */
  onMouseDown: PropTypes.func,
  /* Handler function for mouse up event */
  onMouseUp: PropTypes.func,
  /* Handler function for mouse leave event */
  onMouseLeave: PropTypes.func,
  /* Any child elements to override the default, exluding the indentation */
  children: PropTypes.node,
  /* style object to add to the wrapper of the node */
  style: stylePropType,
  /* className to add to the wrapper of the node */
  className: PropTypes.string,
  /* Determines if the node is expandable, if applicable */
  isExpandable: PropTypes.bool,
  /* Determines if the node can be selected individually, if applicable */
  isSingleSelectable: PropTypes.bool,
  /* Determines if then node can be selected as a part of a group, if applicable */
  isMultiSelectable: PropTypes.bool,
  /* Determines if the node can be highlighted, if applicable */
  isHighlighted: PropTypes.bool
};
export default TreeNode;
//# sourceMappingURL=TreeNode.js.map